export default {
      id: "ic_menu_virtual_bet-usage",
      viewBox: "0 0 38 30",
      url: "/" + "images/icons.3.109.2.svg#ic_menu_virtual_bet-usage",
      toString: function () {
        return this.url;
      }
    }